<template>
  <img
    :class="[effect, { loaded: loaded }]"
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
  />
</template>
<script setup lang="ts">
import { useImage } from '@vueuse/core';

interface Props {
  src?: string;
  alt: string;
  effect?: 'fade-in' | 'scale-in' | 'scale-and-fade' | 'none';
  width?: number;
  height?: number;
}

const props = defineProps({
  src: null,
  alt: null,
  effect: { default: 'fade-in' },
  width: null,
  height: null
});

const emit = defineEmits(["load"]);

const loaded = ref(false);

const srcLoaded = ref('');

const imageOptions = ref({ src: '/images/clear.png' });

const { isLoading, error } = useImage(imageOptions, { delay: 0 });

watchEffect(() => {
  if (props.src) {
    imageOptions.value.src = props.src;
  }
});

watchEffect(() => {
  if (
    !isLoading.value &&
    !error.value &&
    imageOptions.value.src !== '/images/clear.png'
  ) {
    srcLoaded.value = imageOptions.value.src;
    loaded.value = true;
    emit('load');
  } else {
    loaded.value = false;
  }
});
</script>
<style lang="scss" scoped>
img {
  transform-origin: 50% 50%;
  &.fade-in {
    transition: opacity 200ms $ease-in-quad 50ms;
    opacity: 0;
    &.loaded {
      opacity: 1;
    }
  }
  &.scale-in {
    transform: scale(0);
    transition: transform 300ms $ease-out-quad;
    &.loaded {
      transform: scale(1);
    }
  }
  &.scale-and-fade {
    transform: scale(0);
    transition: opacity 300ms $ease-in-quad, transform 300ms $ease-out-quad;
    opacity: 0;
    &.loaded {
      transform: scale(1);
      opacity: 1;
    }
  }
}
</style>
